import { PropsWithChildren } from "react";
import { Box, Flex, FlexProps, styled } from "styled-system/jsx";

type DraggableItemProps = PropsWithChildren &
  FlexProps & {
    iconRightAligned?: boolean;
  };

export const DraggableItem = ({
  children,
  iconRightAligned = false,
  ...props
}: DraggableItemProps) => {
  return (
    <Flex
      gap={"250"}
      alignItems={"center"}
      width={"full"}
      cursor={"pointer"}
      {...props}
    >
      {!iconRightAligned && (
        <styled.img src={"/icons/grabber.svg"} alt={""} w={"20px"} h={"20px"} />
      )}
      <Box width={"full"} minW={0}>
        {children}
      </Box>
      {iconRightAligned && (
        <styled.img src={"/icons/grabber.svg"} alt={""} w={"20px"} h={"20px"} />
      )}
    </Flex>
  );
};
